export default __webpack_public_path__ + "static/icon-28-2-601d62ff4e93f76264cea50dc245cbad.png";